import { View, Text, StyleSheet } from 'react-native';
import { useNetworkStore, ConnectivityState } from '../stores/networkStore';
import { useTheme } from '../theme/ThemeContext';

const MESSAGES: Record<Exclude<ConnectivityState, 'online'>, string> = {
  offline: 'You are offline',
  'server-down': 'Server is temporarily unavailable',
};

const COLORS: Record<Exclude<ConnectivityState, 'online'>, string> = {
  offline: '#b45309',       // amber-700
  'server-down': '#dc2626', // red-600
};

const BG_COLORS: Record<Exclude<ConnectivityState, 'online'>, string> = {
  offline: '#fef3c7',       // amber-100
  'server-down': '#fee2e2', // red-100
};

export default function ConnectivityBanner() {
  const connectivityState = useNetworkStore((s) => s.connectivityState);
  const { colors } = useTheme();

  if (connectivityState === 'online') return null;

  return (
    <View style={[styles.banner, { backgroundColor: BG_COLORS[connectivityState] }]} testID="connectivity-banner" accessibilityLabel={MESSAGES[connectivityState]}>
      <Text style={[styles.text, { color: COLORS[connectivityState] }]}>
        {MESSAGES[connectivityState]}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  banner: {
    paddingVertical: 8,
    paddingHorizontal: 16,
    alignItems: 'center',
  },
  text: {
    fontSize: 14,
    fontWeight: '600',
  },
});
